import React from "react";
import './App.css';
import {
	BrowserRouter as Router,
	Routes,
	Route,
} from "react-router-dom";
import Home from "./pages";
import Collection from "./pages/collection";
import About from "./pages/about";
import Collections from "./pages/collections";
import ContactUs from "./pages/contact-us";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <Router>
	{/* <Navbar /> */}
	<ScrollToTop/>
	<Routes>
		<Route exact path="/" element={<Home />} />
		<Route path="/about" element={<About />} />
		<Route path="/contact-us" element={<ContactUs />} />
		<Route path="/collections" element={<Collections />} />
    <Route path="/collection/:slug" element={<Collection />} />
	</Routes>
</Router>
  );
}

export default App;